<div class="overflow-page-container iframe-documentation">
  <div class="full-width">
		<iframe #iframe [src]="srcUrl" title="docs"></iframe>
  </div>

</div>
